import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Typography } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

const useStyles = makeStyles(theme => ({
	pagination: {
		marginTop: theme.spacing(3),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end'
	}
}));

const PaginationView = ({
	currentPage,
	numberPerPage,
	totalResult,
	pageLess,
	pageMore
}) => {
	const classes = useStyles();

	return (
		<div className={classes.pagination}>
			<Typography variant='caption'>
				{currentPage * numberPerPage - numberPerPage + 1} -{' '}
				{currentPage * numberPerPage > totalResult
					? totalResult
					: currentPage * numberPerPage}{' '}
				of {totalResult}
			</Typography>
			<IconButton onClick={pageLess}>
				<ChevronLeftIcon />
			</IconButton>
			<IconButton onClick={pageMore}>
				<ChevronRightIcon />
			</IconButton>
		</div>
	);
};

export default PaginationView;
